<template>
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        enable-background="new 0 0 24 24"
        xml:space="preserve"
    >
        <g id="Outline_Icons_1_">
            <g id="Outline_Icons">
                <g>
                    <path
                        :fill="color"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        d="M12,16.5c1.5,0,5-2,5-5c1.5,0,1.5-3,0-3L16.5,6c-4,0-4-1.5-4.5-2c-0.5,0.5-0.5,2-4.5,2L7,8.5c-1.5,0-1.5,3,0,3C7,14.5,10.5,16.5,12,16.5z"
                    />
                    <path
                        :fill="color"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        d="M17.977,9.219L18.5,5.5c0,0,0.5-5-6.5-5s-6.5,5-6.5,5l0.533,3.695"
                    />
                    <path
                        :fill="color"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        d="M9.27,15.382l-6.174,1.873C1.535,17.84,0.5,19.332,0.5,21v2.5h23V21c0-1.668-1.034-3.16-2.596-3.745l-6.174-1.873"
                    />
                    <path
                        :fill="color"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        d="M9,9.5C9,8.947,9.448,9,10,9s1-0.053,1,0.5"
                    />
                    <path
                        :fill="color"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        d="M13,9.5C13,8.947,13.448,9,14,9s1-0.053,1,0.5"
                    />
                </g>
            </g>
            <g id="New_icons_1_" />
        </g>
        <g id="Invisible_Shape">
            <rect
                fill="none"
                width="24"
                height="24"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "UserIcon",
    props: {
        active: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        color() {
            return this.active ? 'gray' : 'white';
        }
    }
}
</script>

<style scoped>

</style>